export const LICENSE_DETAILS_UFO_NAME = 'mac-account-details-render';
export const LICENSE_TRACKED_ELSEWHERE_FETCH_UFO_NAME = 'mac-tracked-elsewhere-fetch';
export const LICENSE_IS_SITE_ON_CONCESSION_FETCH_UFO_NAME = 'mac-is-site-on-concession-fetch';
export const LICENSE_IS_RENEWABLE_ACCOUNT_FETCH_UFO_NAME = 'mac-is-renewable-account-fetch';
export const LICENSE_IS_UPGRADABLE_ACCOUNT_FETCH_UFO_NAME = 'mac-is-upgradable-account-fetch';
export const LICENSE_IS_ON_BEHALF_OF_EMAIL_FETCH_UFO_NAME = 'mac-is-on-behalf-of-email-fetch';
export const LICENSE_IS_HOSTED_ACCOUNT_PROVISIONING_FETCH_UFO_NAME =
  'mac-is-hosted-account-provisioning-fetch';
export const ORDER_LOOKUP_SUBMIT_UFO_NAME = 'mac-order-lookup-submit';
export const ORDER_INVOICE_ACTION_PDF_UFO_NAME = 'mac-order-invoice-action-pdf';
export const CHECKOUT_CONTACTS_SUBMIT_UFO_NAME = 'checkout-contacts-submit';
export const UPGRADE_SUBMIT_CHANGELIST_UFO_NAME = 'upgrade-submit-changelist';
export const CART_SUBMIT_STRIPE_UFO_NAME = 'cart-submit-stripe';
export const CART_SUBMIT_CONVERT_TO_QUOTE_UFO_NAME = 'cart-submit-convert-to-quote';
export const CART_SUBMIT_PAY_ON_TERMS_UFO_NAME = 'cart-submit-pay-on-terms';
export const CART_SUBMIT_PAY_ON_ACCOUNT_UFO_NAME = 'cart-submit-pay-on-account';
export const CART_SUBMIT_PAYPAL_UFO_NAME = 'cart-submit-paypal';
export const CART_SUBMIT_FREE_UFO_NAME = 'cart-submit-free';
export const ITEMS_ADD_UFO_NAME = 'items-add';
export const UNKNOWN_PAYMENT_METHOD_UFO_NAME = 'unknown-payment-method';
